import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var CybersourceModalService = /** @class */ (function () {
    function CybersourceModalService() {
        this.currentDataPay = new BehaviorSubject(this.dataPay);
        this.fraudType = new BehaviorSubject(null);
    }
    CybersourceModalService.prototype.sendDataPayment = function (dataPayment, idOperation, fraudType) {
        this.dataPay = Object.assign(dataPayment, { idOperation: idOperation });
        this.currentDataPay.next(this.dataPay);
        this.fraudType.next(fraudType);
    };
    CybersourceModalService.prototype.getObject = function () {
        return this.currentDataPay.asObservable();
    };
    CybersourceModalService.prototype.getFraudType = function () {
        return this.fraudType.asObservable();
    };
    CybersourceModalService.prototype.reset = function () {
        this.dataPay = null;
        this.currentDataPay.next(this.dataPay);
        this.fraudType.next(null);
    };
    CybersourceModalService.ngInjectableDef = i0.defineInjectable({ factory: function CybersourceModalService_Factory() { return new CybersourceModalService(); }, token: CybersourceModalService, providedIn: "root" });
    return CybersourceModalService;
}());
export { CybersourceModalService };
